import { createPortal } from 'react-dom';
import { createStoreHooks } from '../../../../canvas/core';

const { useStore } = createStoreHooks();

export const ViewportCenterDebugOverlay = () => {
  const viewportDims = useStore(s => s.canvas.viewportRect);

  const viewportCenterX = viewportDims.width / 2;
  const viewportCenterY = viewportDims.height / 2;
  const overlayElement = useStore(s => s.canvas.refs.overlayRef).current;

  if (!overlayElement) {
    return null;
  }

  return createPortal(
    <circle
      cx={viewportCenterX}
      cy={viewportCenterY}
      r={4}
      fill="red"
      stroke="white"
      strokeWidth={1}
      style={{ pointerEvents: 'none' }}
    />,
    overlayElement
  );
};
